import React, {useEffect, useState} from 'react';
import './GameEquipment.css';
import Menu from "../../../Components/Menu/Menu";
import {useNavigate, useSearchParams} from "react-router-dom";
import axios from "axios";

const GameEquipment = () => {

    const [searchParams] = useSearchParams();
    const idFromUrl = searchParams.get('id');

    const navigate = useNavigate();
    const [choosedBox, setChoosedBox] = useState(null);
    const [boxes, setBoxes] = useState(null);

    useEffect(() => {
        if (idFromUrl) {
            setChoosedBox(parseInt(idFromUrl.split('-')[2]));
            // setChoosedBox(idFromUrl.split('-')[2]);
        }
    }, [idFromUrl, setChoosedBox]);

    useEffect(() => {
        axios.get(`/api/give_inventory/`, {headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                // 'X-CSRFToken': getCookie('csrftoken'),
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true})
            .then(res => {
                if (res.data.detail.length !== 0) {
                    setBoxes(res.data.detail);
                }
            })
            .catch(e => {
                console.log(e);
                if (e.status === 401) {
                    navigate('/login');
                }
            })
    }, [setBoxes]);

    const goBack = () => {
        if (window.history.length > 1) {
            navigate(-1);
        } else {
            navigate('/box_reserve');
        }
    }

    const selectBox = (num) => {
        setChoosedBox(num);
    }

    const openBox = () => {
        if (choosedBox && boxes) {
            console.log(boxes[choosedBox-1].id, ' ', boxes[choosedBox-1].name);
            axios.get(`/api/open_inventory/?id=${boxes[choosedBox-1].id}`, {headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    // 'X-CSRFToken': getCookie('csrftoken'),
                    'Access-Control-Allow-Headers': 'X-CSRFToken'
                }, withCredentials: true})
                .then(res => {
                    if (res.status === 200) {
                        console.log('Дверь успешно открыта')
                        alert('Ящик открыт');
                    }
                })
                .catch(e => {
                    console.log(e);
                    if (e.status === 401) {
                        navigate('/login');
                    }
                })
        }
    }

    return (
        <div className={'game-equipment-container'}>
            <Menu/>
            <div className={'game-equipment-title'}>Инвентарь:</div>

            <div className={'game-equipment-box-container'}>
                <div className={`game-equipment-box ${choosedBox === 1 ? 'game-equipment-box-selected' : ''} ${boxes?.[0]?.is_blocked ? 'g-box-blocked-user' : ''}`} onClick={() => selectBox(1)}>
                    <p className={'game-equipment-box-number'}>10</p>
                    <svg version="1.1" className={'game-equipment-box-logo'} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="-12 20 130 75">
                        <path fill="white" d="M98.84,40.96c-1.04-3.37-3.09-6.04-5.81-8.23c-2.87-2.32-6.16-3.48-9.86-3.43c-1.54,0.02-3.04,0.29-4.5,0.76
                            c-2.85,0.91-5.4,2.39-7.72,4.25c-3.81,3.05-6.97,6.64-9,11.12c-0.75,1.65-1.31,3.36-1.5,5.18c-0.07,0.67-0.04,1.35-0.15,2.01
                            c-0.23,1.46-0.53,2.9-0.79,4.35c-0.55,3.05-1.25,6.07-2.15,9.04c-0.42,1.38-0.92,2.73-1.63,3.99c-0.71-1.26-1.21-2.61-1.63-3.99
                            c-0.9-2.97-1.6-5.98-2.15-9.04c-0.26-1.45-0.56-2.9-0.79-4.35c-0.11-0.66-0.08-1.34-0.15-2.01c-0.19-1.81-0.75-3.53-1.5-5.18
                            c-2.04-4.48-5.19-8.07-9-11.12c-2.33-1.86-4.87-3.34-7.72-4.25c-1.46-0.47-2.96-0.74-4.5-0.76c-3.7-0.05-6.99,1.11-9.86,3.43
                            c-2.72,2.19-4.76,4.86-5.81,8.23c-0.82,2.66-0.86,5.34-0.17,8.03c0.98,3.87,3.04,7.14,5.63,10.11c1.9,2.17,4.02,4.1,6.43,5.7
                            c2.42,1.61,5.01,2.83,7.89,3.38c0.81,0.15,1.65,0.15,2.47,0.27c1.01,0.14,2.02,0.31,3.03,0.48c2.93,0.51,5.85,1.1,8.72,1.88
                            c1.92,0.53,4.04,1.02,5.83,1.94c-0.05,0.03-0.1,0.07-0.14,0.12c-2.46,2.46-9.25,8.92-11.67,11.34c-0.28,0.28-0.35,0.69-0.2,1.04
                            c-0.29,0.3-0.45,0.48-0.44,0.49c0.66,0.69,1.34,1.36,2.02,2.03c0.2,0.2,0.38,0.52,0.61,0.55c0.03,0,0.21-0.15,0.5-0.42
                            c0.33,0.13,0.72,0.06,0.99-0.21c2.41-2.41,9.11-8.79,11.61-11.28c2.5,2.49,9.2,8.87,11.61,11.28c0.27,0.27,0.66,0.34,0.99,0.21
                            c0.3,0.27,0.47,0.42,0.5,0.42c0.23-0.04,0.41-0.36,0.61-0.55c0.68-0.67,1.36-1.34,2.02-2.03c0.01-0.01-0.15-0.19-0.44-0.49
                            c0.15-0.34,0.08-0.76-0.2-1.04c-2.42-2.42-9.21-8.88-11.67-11.34c-0.04-0.04-0.09-0.08-0.14-0.12c1.79-0.92,3.91-1.41,5.83-1.94
                            c2.87-0.79,5.79-1.37,8.72-1.88c1.01-0.18,2.02-0.34,3.03-0.48c0.82-0.11,1.66-0.11,2.47-0.27c2.87-0.55,5.47-1.76,7.89-3.38
                            c2.41-1.6,4.53-3.53,6.43-5.7c2.59-2.97,4.65-6.25,5.63-10.11C99.7,46.3,99.66,43.62,98.84,40.96z M40.71,62.84
                            c-2.17,1.39-4.54,1.81-7.09,1.39c-2.46-0.41-4.65-1.45-6.7-2.81c-2.48-1.65-4.64-3.66-6.5-5.99c-1.68-2.11-3.07-4.37-3.84-6.98
                            c-0.85-2.89-0.77-5.7,0.78-8.35c1.16-2,2.74-3.61,4.63-4.93c1.65-1.16,3.47-1.83,5.51-1.79c0.01-0.03,0.01-0.07,0.02-0.1
                            c1.04,0.16,2.09,0.25,3.1,0.49c2.03,0.47,3.87,1.41,5.59,2.57c3.31,2.24,6.07,5.02,8.21,8.41c1.32,2.08,2.26,4.29,2.57,6.75
                            c0.26,2.06-0.08,4.02-1.07,5.84C44.68,59.64,42.9,61.45,40.71,62.84z M43.63,65.82c2.01-1.25,3.62-2.87,4.87-4.86
                            c0.58,2.24,1.15,4.43,1.71,6.58C48.05,66.97,45.87,66.4,43.63,65.82z M61.24,67.53c0.56-2.15,1.13-4.34,1.71-6.58
                            c1.25,1.99,2.86,3.61,4.87,4.86C65.59,66.4,63.41,66.97,61.24,67.53z M94.87,48.45c-0.77,2.61-2.16,4.87-3.84,6.98
                            c-1.86,2.33-4.02,4.34-6.5,5.99c-2.05,1.36-4.24,2.4-6.7,2.81c-2.54,0.43-4.91,0-7.09-1.39c-2.19-1.4-3.96-3.21-5.21-5.5
                            c-0.99-1.82-1.33-3.78-1.07-5.84c0.31-2.46,1.25-4.68,2.57-6.75c2.14-3.39,4.9-6.17,8.21-8.41c1.72-1.16,3.56-2.1,5.59-2.57
                            c1.02-0.24,2.07-0.33,3.1-0.49c0.01,0.03,0.01,0.07,0.02,0.1c2.05-0.05,3.86,0.63,5.51,1.79c1.89,1.32,3.47,2.94,4.63,4.93
                            C95.64,42.75,95.72,45.56,94.87,48.45z"/>
                    </svg>

                </div>
                <div className={`game-equipment-box ${choosedBox === 2 ? 'game-equipment-box-selected' : ''} ${boxes?.[1]?.is_blocked ? 'g-box-blocked-user' : ''}`} onClick={() => selectBox(2)}>
                    <p className={'game-equipment-box-number'}>11</p>
                    <svg version="1.1" className={'game-equipment-box-logo'} xmlns="http://www.w3.org/2000/svg" x="0px"
                         y="0px" viewBox="-12 20 130 75">
                        <path fill="white" d="M98.84,40.96c-1.04-3.37-3.09-6.04-5.81-8.23c-2.87-2.32-6.16-3.48-9.86-3.43c-1.54,0.02-3.04,0.29-4.5,0.76
                            c-2.85,0.91-5.4,2.39-7.72,4.25c-3.81,3.05-6.97,6.64-9,11.12c-0.75,1.65-1.31,3.36-1.5,5.18c-0.07,0.67-0.04,1.35-0.15,2.01
                            c-0.23,1.46-0.53,2.9-0.79,4.35c-0.55,3.05-1.25,6.07-2.15,9.04c-0.42,1.38-0.92,2.73-1.63,3.99c-0.71-1.26-1.21-2.61-1.63-3.99
                            c-0.9-2.97-1.6-5.98-2.15-9.04c-0.26-1.45-0.56-2.9-0.79-4.35c-0.11-0.66-0.08-1.34-0.15-2.01c-0.19-1.81-0.75-3.53-1.5-5.18
                            c-2.04-4.48-5.19-8.07-9-11.12c-2.33-1.86-4.87-3.34-7.72-4.25c-1.46-0.47-2.96-0.74-4.5-0.76c-3.7-0.05-6.99,1.11-9.86,3.43
                            c-2.72,2.19-4.76,4.86-5.81,8.23c-0.82,2.66-0.86,5.34-0.17,8.03c0.98,3.87,3.04,7.14,5.63,10.11c1.9,2.17,4.02,4.1,6.43,5.7
                            c2.42,1.61,5.01,2.83,7.89,3.38c0.81,0.15,1.65,0.15,2.47,0.27c1.01,0.14,2.02,0.31,3.03,0.48c2.93,0.51,5.85,1.1,8.72,1.88
                            c1.92,0.53,4.04,1.02,5.83,1.94c-0.05,0.03-0.1,0.07-0.14,0.12c-2.46,2.46-9.25,8.92-11.67,11.34c-0.28,0.28-0.35,0.69-0.2,1.04
                            c-0.29,0.3-0.45,0.48-0.44,0.49c0.66,0.69,1.34,1.36,2.02,2.03c0.2,0.2,0.38,0.52,0.61,0.55c0.03,0,0.21-0.15,0.5-0.42
                            c0.33,0.13,0.72,0.06,0.99-0.21c2.41-2.41,9.11-8.79,11.61-11.28c2.5,2.49,9.2,8.87,11.61,11.28c0.27,0.27,0.66,0.34,0.99,0.21
                            c0.3,0.27,0.47,0.42,0.5,0.42c0.23-0.04,0.41-0.36,0.61-0.55c0.68-0.67,1.36-1.34,2.02-2.03c0.01-0.01-0.15-0.19-0.44-0.49
                            c0.15-0.34,0.08-0.76-0.2-1.04c-2.42-2.42-9.21-8.88-11.67-11.34c-0.04-0.04-0.09-0.08-0.14-0.12c1.79-0.92,3.91-1.41,5.83-1.94
                            c2.87-0.79,5.79-1.37,8.72-1.88c1.01-0.18,2.02-0.34,3.03-0.48c0.82-0.11,1.66-0.11,2.47-0.27c2.87-0.55,5.47-1.76,7.89-3.38
                            c2.41-1.6,4.53-3.53,6.43-5.7c2.59-2.97,4.65-6.25,5.63-10.11C99.7,46.3,99.66,43.62,98.84,40.96z M40.71,62.84
                            c-2.17,1.39-4.54,1.81-7.09,1.39c-2.46-0.41-4.65-1.45-6.7-2.81c-2.48-1.65-4.64-3.66-6.5-5.99c-1.68-2.11-3.07-4.37-3.84-6.98
                            c-0.85-2.89-0.77-5.7,0.78-8.35c1.16-2,2.74-3.61,4.63-4.93c1.65-1.16,3.47-1.83,5.51-1.79c0.01-0.03,0.01-0.07,0.02-0.1
                            c1.04,0.16,2.09,0.25,3.1,0.49c2.03,0.47,3.87,1.41,5.59,2.57c3.31,2.24,6.07,5.02,8.21,8.41c1.32,2.08,2.26,4.29,2.57,6.75
                            c0.26,2.06-0.08,4.02-1.07,5.84C44.68,59.64,42.9,61.45,40.71,62.84z M43.63,65.82c2.01-1.25,3.62-2.87,4.87-4.86
                            c0.58,2.24,1.15,4.43,1.71,6.58C48.05,66.97,45.87,66.4,43.63,65.82z M61.24,67.53c0.56-2.15,1.13-4.34,1.71-6.58
                            c1.25,1.99,2.86,3.61,4.87,4.86C65.59,66.4,63.41,66.97,61.24,67.53z M94.87,48.45c-0.77,2.61-2.16,4.87-3.84,6.98
                            c-1.86,2.33-4.02,4.34-6.5,5.99c-2.05,1.36-4.24,2.4-6.7,2.81c-2.54,0.43-4.91,0-7.09-1.39c-2.19-1.4-3.96-3.21-5.21-5.5
                            c-0.99-1.82-1.33-3.78-1.07-5.84c0.31-2.46,1.25-4.68,2.57-6.75c2.14-3.39,4.9-6.17,8.21-8.41c1.72-1.16,3.56-2.1,5.59-2.57
                            c1.02-0.24,2.07-0.33,3.1-0.49c0.01,0.03,0.01,0.07,0.02,0.1c2.05-0.05,3.86,0.63,5.51,1.79c1.89,1.32,3.47,2.94,4.63,4.93
                            C95.64,42.75,95.72,45.56,94.87,48.45z"/>
                    </svg>
                </div>
            </div>

            <div className={'game-equipment-button-container'}>
                <div className={'game-equipment-button g-eq-btn-opn'} onClick={() => openBox()}>Открыть шкаф</div>
                <div className={'game-equipment-button g-eq-btn-back'} onClick={() => goBack()}>Назад</div>
            </div>
        </div>
    );
};

export default GameEquipment;